import React, { Component } from "react";
import { Link } from 'react-router-dom';

import defaultAvatar from '../../../images/default-avatar.jpg';

class LeftPane extends Component {

    getButton() {
        const { inputProps:{order, isFetching, session:{isLoggedIn, currentUser}} } = this.props;
        let isCompleted = (order.status === 5 || order.status === 6);
        let isCustomer = (order.user_id === currentUser.id);
        let isRating = (order.contractor_minimal_rating > currentUser.summary_rating && !order.is_my_bid);
        let isCanceled = (order.is_failed);

        if(!isLoggedIn) {
            return  [
                    <div key="st1" className="big-button button-action perform-order">
                        <button className="disabled" disabled title="Выполнить заказ могут только зарегистрированные пользователи.">Хочу выполнить!</button>
                    </div>,
                    <div key="st2" style={{marginTop: '30px',background: '#E74C3C', color: '#fff', padding: '10px'}}>
                        Выполнить заказ могут только зарегистрированные пользователи.
                    </div>
                ]
        }

        if(isCanceled) {
            return  <div style={{
                marginTop: '30px',
                background: '#E74C3C',
                color: '#fff',
                padding: '10px'
            }}>
                {`Заказ отменен. ${order.fail_reason_str || ''}`}
            </div>
        }

        if(isCustomer) return false; //Свой заказ

        if(order.my_bid_status === 6 || order.my_bid_status === 7) {
            return <div
                style={{
                    marginTop: '30px',
                    background: '#E74C3C',
                    color: '#fff',
                    padding: '10px'
                }}>
                Ваш отклик отклонен
            </div>
        }

        if(isCompleted) {
            return  <div key="st2" style={{marginTop: '30px',background: '#E74C3C', color: '#fff', padding: '10px'}}>
                        Заказ выполнен
                    </div>
        }

        if(isRating) {
            return  [
                    <div key="st1" className="big-button button-action perform-order">
                        <button className="disabled" disabled title={`Минимальный рейтинг исполнителя должен быть ${order.contractor_minimal_rating}`}>
                            Хочу выполнить!
                        </button>
                    </div>,
                    <div key="st2" style={{marginTop: '30px',background: '#E74C3C', color: '#fff', padding: '10px'}}>
                        {`Минимальный рейтинг исполнителя должен быть ${order.contractor_minimal_rating}`}
                    </div>
                ]
        }
        
        if(order.is_my_bid) {
            return  <div className="you-responded text_green">
                        вы откликнулись
                    </div>
        }

        if(order.status === 1 || order.status === 2) {
            return  <div className="button-action big-button perform-order">
                        <button 
                            onClick={() => this.props.handleResponseOrder(order.id)} 
                            title={"Хочу выполнить!"}
                            className={isFetching ? "disabled" : ""}
                        >
                            Хочу выполнить!
                        </button>
                    </div>
        }
    }

    render() {

        const { inputProps, handleResponseOrder } = this.props;
        const { session, order, user, isFetching } = inputProps;
        const {isLoggedIn, currentUser} =  session;

        let buttonTitle = "Откликаться на заказ";
        let buttonText = "Откликаться на заказ";
        let buttonStatus = true;

        if(currentUser.summary_rating < order.contractor_minimal_rating){
            buttonText = `Минимальный рейтинг исполнителя должен быть ${order.contractor_minimal_rating}`;
            buttonStatus = false;
        }
        if(!isLoggedIn) {
            buttonText = `Выполнить заказ могут только зарегистрированные пользователи.`;
            buttonStatus = false;
        }
        if(order.status === 5 || order.status === 6) {
            buttonTitle = `Заказ выполнен`;
            buttonText = `Заказ выполнен`;
            buttonStatus = false;
        }
        
        return (
            <div className="left-content left-content-width" style={{justifyContent: "start"}}>
                <div className="left-content-orders">
                    <h2 className="main-title-orders">
                        <span
                            className="text_gradient_violet_circle"
                            style={{
                                marginRight: "20px",
                                backgroundImage: "radial-gradient(circle at 27% 87%, rgb(0, 0, 0), rgb(0, 0, 0) 73%, rgb(0, 0, 0))"
                            }}>Заказ</span>
                        <span 
                            className="text_gradient_orange disabled"
                            style={{backgroundImage: "linear-gradient(118deg, rgb(218, 73, 175), rgb(254, 55, 56) 49%, rgb(249, 181, 62))"}}>
                            № {order.id}
                            </span>
                    </h2>
                    <div className="menu-content-nav customer-info">
                        <span className="from">от</span>
                        <div className="customer-info-profile">
                            <div className="avatar">
                                {
                                    user && user.avatar
                                    ? <div className="img" style={{backgroundImage: `url(${user.avatar})`}}></div>
                                    : <div className="img" style={{backgroundImage: `url(${defaultAvatar})`}}></div>
                                }
                            </div>
                            <div className="text">
                                <div className="name">
                                {
                                    user ?
                                    <Link to={`/profile/${user.id}`}>
                                        {user.first_name}
                                        <br />
                                        {user.last_name}
                                        <br />
                                        {user.patronymic_name}
                                    </Link>
                                    : ''
                                }
                                </div>
                                {
                                    order.company ?
                                    <div className="company">{order.company}</div>
                                    : ''
                                }
                            </div>
                        </div>
                        {
                            order.is_test
                            ?
                            <div className="budget">
                                <span className="text_pink_d">Тестовый заказ</span>
                            </div>
                            :
                            <div className="budget">
                                Бюджет: <span className="text_pink_d">{order.price} руб.</span>
                            </div>
                        }


                        {this.getButton(order, currentUser, isLoggedIn, isFetching, handleResponseOrder)}

                    </div>
                </div>
            </div>
        )
    }
}

export default LeftPane;


// WEBPACK FOOTER //
// ./src/components/Orders/Execute/LeftPane.js